import StatsModule from './containers/statsModule'

export {default as StatsModuleLayout} from './components/statsModuleLayout'

export default StatsModule
